module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fMZxoQ/images/cover.jpg?1684514595154",
      "alt": "This image is the cover for the book Love Means... Renewal, Love Means... Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Love Means... Renewal, Love Means... Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("A Love Means... Story")])])]), _c('p', [_vm._v("Eli Henninger is stretched a little thin. He teaches riding classes, conducts therapy sessions, takes care of his son, and helps manage the family farm. He’s tired and overworked, especially because lately, no one else seems to do anything right. He and his partner, Geoff, haven’t have time together in so long, he’s beginning to forget what his longtime love feels like.")]), _vm._v(" "), _c('p', [_vm._v("Geoff is just as busy with the farm, the business, and working through a complicated land purchase. He and Eli labor from sunup to sundown and then some. He knows taking care of their responsibilities is preventing them from taking care of each other, but he doesn’t see anything he can do about it. To make matters worse, they’re accused of behaving improperly toward some of the children in their riding programs.")]), _vm._v(" "), _c('p', [_vm._v("Then Eli becomes ill and the investigators suspect foul play, forcing Geoff to reevaluate his priorities and hope fate will give them another chance.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Andrew Grey\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0